import { createSelector } from '@ngrx/store';
import { AppState } from '..';
import { InsightsState } from './insights.reducer';

const $insightsState = (state: AppState): InsightsState => state.insights;

export const $insightsLoading = createSelector(
    $insightsState,
    state => state.loading,
);

export const $insightsDashboards = createSelector($insightsState, state => ({
    dashboards: state.dashboards,
    url: state.url,
}));

export const $insightsToken = createSelector(
    $insightsState,
    state => state.token,
);
